import { FC, useContext, useEffect } from "react";
import { Button, CircularProgress, Typography, useTheme } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { PhysicalExaminationContext } from ".";
import { useForm } from "react-hook-form";
import { AddPhysicalComponentPropType } from "./types";
import { useMutation } from "react-query";
import { postPhysicalExamination } from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
import { EmrContext } from "../../index";

const AddPhysicalExamination: FC<AddPhysicalComponentPropType> = ({
  close,
}) => {
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { edit, setRefetch, setEdit } = useContext(PhysicalExaminationContext);
  const { triggerConsultationStart } = useContext(EmrContext);
  const { control, handleSubmit, reset } = useForm();
  const theme = useTheme();

  const { mutate: savePhysicalExamination, isLoading: saveLoading } =
    useMutation(postPhysicalExamination, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            variant: "success",
            open: true,
            duration: 2000,
          });
          triggerConsultationStart();
          setRefetch(true);
          reset({ description: "" });
          setEdit(null);
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            open: true,
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          variant: "success",
          open: true,
          duration: 2000,
        });
      },
    });

  const onSubmit = (value: any) => {
    triggerConsultationStart();
    if (Boolean(edit)) {
      savePhysicalExamination({
        ...edit,
        ...value,
        encounter: parseInt(encounterId as string),
        ip: "",
        isModified: 0,
        status: 1,
        description: value.description,
        revertFlag: false,
      });
    } else {
      savePhysicalExamination({
        id: 0,
        encounter: parseInt(encounterId as string),
        ip: "",
        isModified: 0,
        status: 1,
        description: value.description,
        revertFlag: false,
      });
    }
  };

  useEffect(() => {
    if (Boolean(edit)) {
      reset({ ...edit });
    } else {
      reset({
        description: "",
      });
    }
  }, [edit]);

  return (
    <div className="border-2 rounded">
      <div className="p-1 border-b  rounded-t" style={{}}>
        <Typography color={theme.palette.primary.main} fontWeight={600}>
          Add Physical Examination
        </Typography>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="p-2 grid grid-cols-10 gap-2"
      >
        <div className="col-span-8">
          <CustomFormField
            name="description"
            control={control}
            element="input"
            fieldProps={{
              label: "Physical examination",
              multiline: true,
              rows: 3,
            }}
            rules={{ required: "Physical examination required" }}
          />
        </div>
        <div className="flex justify-end items-end gap-3 col-span-2">
          <Button
            type="submit"
            color="success"
            disabled={saveLoading}
            endIcon={saveLoading && <CircularProgress size={18} />}
          >
            {" "}
            save{" "}
          </Button>
          <Button
            color="error"
            onClick={() => {
              close && close();
            }}
          >
            close
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddPhysicalExamination;
